import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const Pending = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Rect x={0.533} y={0.95} width={22} height={22} rx={11} fill="#fff" />
    <G clipPath="url(#a)">
      <Path
        d="M11.533 3.04a8.908 8.908 0 0 0-8.91 8.91 8.908 8.908 0 0 0 8.91 8.91 8.908 8.908 0 0 0 8.91-8.91 8.908 8.908 0 0 0-8.91-8.91Zm1.174 12.458c0 .348-.11.604-.321.779-.211.174-.477.256-.798.256-.32 0-.586-.082-.797-.256-.211-.175-.321-.431-.321-.78v-4.335c0-.349.11-.605.32-.78.212-.174.477-.256.798-.256.321 0 .587.082.798.257.21.174.32.43.32.779v4.335Zm-.22-6.545c-.22.201-.523.293-.899.293s-.678-.101-.898-.293c-.22-.202-.33-.459-.33-.789s.11-.586.33-.779c.22-.192.522-.293.898-.293s.67.1.899.293c.229.193.339.45.339.78s-.11.586-.33.788h-.01Z"
        fill="#EE6654"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(.533 .95)" d="M0 0h22v22H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Pending
